import * as Yup from 'yup';

export const overridePriceValidation = Yup.object({
  amount: Yup.string().required('Required'),
  sessionId: Yup.string().required('Required'),
});

export type TOverridePrice = Yup.InferType<typeof overridePriceValidation>;
